import { MenuItem, useToast } from '@chakra-ui/react'
import * as crypto from 'crypto-js'
import fileDownload from 'js-file-download'
import { FC, useState } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useTools from '@hook/shared/use-tools'

import kpi from '@service/kpi'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ExcelRuptureKpi: FC<ILayoutToolsExportAction> = () => {
  const { isDisabled } = useTools()
  const toast = useToast()
  const [loading, setLoading] = useState(false)

  const dataFetch = async () => {
    try {
      setLoading(true)
      let newParams = {}
      if (localStorage.getItem('kpiRuptureParamsRequest')) {
        newParams = JSON.parse(
          crypto.AES.decrypt(
            localStorage.getItem('kpiRuptureParamsRequest'),
            'CHAVE'
          ).toString(crypto.enc.Utf8) || ''
        )
      }
      const { data: res } = await kpi.postRuptureIndicatorExportModalData(
        newParams
      )
      fileDownload(res, 'Kpi-Ruptura.csv')
    } catch (error: any) {
      const { data } = error.response
      const message =
        data.response?.status === 400
          ? data.response?.data?.data[0].message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isDisabled || loading}
      onClick={dataFetch}
      icon={<GrDocumentCsv />}
    >
      Exportar para Tabela
    </MenuItem>
  )
}
export default ExcelRuptureKpi
